import type { Bid } from '@autobid/ui/types/Bid'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { ALL_BIDS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAllBidsSocket'
import { allBidsQueryKey } from '@autobid/ui/composables/car/useAllBids'
import { useQueryClient } from '@tanstack/vue-query'

export function useAllBidsBidDeleted() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const bidDeleted = () => {
    startListen({
      eventName: 'premium.BID_DELETED',
      callbackName: ALL_BIDS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, price } = event.context
        const queryKey = allBidsQueryKey.byCarId(carId)

        queryClient.setQueryData(queryKey, (bids?: Bid[]) => {
          if (!bids) {
            return bids
          }

          return bids.filter(bid => bid.amount !== price)
        })
      },
    })
  }

  return { bidDeleted }
}
